export default __webpack_public_path__ + "static/media/0G.87d131c4.png";